
// import React, { useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";

// function About() {
//   const [expandedBhaktamar, setExpandedBhaktamar] = useState(false);
//   const [expandedDrPranamsagar, setExpandedDrPranamsagar] = useState(false);

//   const slideVariant = {
//     hidden: { opacity: 0, height: 0 },
//     visible: { opacity: 1, height: "auto", transition: { duration: 0.6 } },
//     exit: { opacity: 0, height: 0, transition: { duration: 0.4 } },
//   };

//   return (
//     <div
//       style={{
//         fontFamily: "'Poppins', sans-serif",
//         background: "linear-gradient(to bottom, #fffaf3, #fff4e2)", // 🌸 soft cream base
//         color: "#4b2e05",
//       }}
//     >
//       {/* 🌟 Hero Section */}
//       <section
//         style={{
//           background: "linear-gradient(120deg, #ffd6b5, #ffebb0, #fff4e2)", // soft peach–gold blend
//           padding: "90px 20px",
//           textAlign: "center",
//           color: "#4b2e05",
//           boxShadow: "inset 0 -5px 15px rgba(255, 200, 100, 0.2)",
//         }}
//       >
//         <motion.h1
//           initial={{ opacity: 0, y: -40 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.8 }}
//           style={{
//             fontSize: "2.8rem",
//             fontWeight: "800",
//             marginBottom: "20px",
//             color: "#5a3a0e",
//             textShadow: "0 2px 8px rgba(255, 230, 150, 0.5)",
//           }}
//         >
//           About Bhaktamar & Acharya Dr. Pranamsagarji Maharaj
//         </motion.h1>
//         <motion.p
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           transition={{ duration: 1 }}
//           style={{
//             fontSize: "1.2rem",
//             maxWidth: "750px",
//             margin: "0 auto",
//             lineHeight: "1.8",
//             color: "#6b4a2e",
//           }}
//         >
//           Discover the divine journey of Bhaktamar Stotra and the visionary teachings
//           of Acharya Dr. Pranamsagarji Maharaj — inspiring millions through devotion,
//           discipline, and wisdom.
//         </motion.p>
//       </section>

//       {/* 🪶 Cards Grid */}
//       <div
//         className="about-grid"
//         style={{
//           display: "grid",
//           gridTemplateColumns: "1fr 1fr",
//           gap: "40px",
//           padding: "60px 20px",
//           maxWidth: "1200px",
//           margin: "0 auto",
//         }}
//       >
//         {/* 🔶 Bhaktamar Card */}
//         <motion.div
//           whileHover={{ scale: 1.02 }}
//           transition={{ duration: 0.3 }}
//           className="about-card"
//           style={{
//             borderRadius: "20px",
//             padding: "3px",
//             background:
//               "linear-gradient(135deg, #ffe7ba, #ffd6b5, #ffc1a1)", // soft golden gradient border
//             boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
//           }}
//         >
//           <div
//             style={{
//               background: "#fffaf3",
//               borderRadius: "18px",
//               padding: "25px",
//               height: "100%",
//               display: "flex",
//               flexDirection: "column",
//               gap: "20px",
//             }}
//           >
//             <motion.img
//               src="bhaktamar.jpg"
//               alt="Bhaktamar"
//               whileHover={{ scale: 1.05 }}
//               transition={{ duration: 0.4 }}
//               style={{
//                 width: "100%",
//                 borderRadius: "15px",
//                 boxShadow: "0 8px 20px rgba(255, 180, 100, 0.4)",
//                 cursor: "pointer",
//                 objectFit: "cover",
//               }}
//             />
//             <div>
//               <h2
//                 style={{
//                   color: "#b66b00",
//                   fontWeight: "700",
//                   marginBottom: "10px",
//                 }}
//               >
//                 Bhaktamar Stotra
//               </h2>
//               <p style={{ fontSize: "1.1rem", color: "#5a3a0e", lineHeight: "1.8" }}>
//                 A revered Jain composition believed to radiate divine vibrations,
//                 bringing healing, positivity, and inner peace through each of its
//                 48 sacred verses.
//               </p>

//               <AnimatePresence>
//                 {expandedBhaktamar && (
//                   <motion.div
//                     key="bhaktamar-content"
//                     variants={slideVariant}
//                     initial="hidden"
//                     animate="visible"
//                     exit="exit"
//                     style={{
//                       overflow: "hidden",
//                       marginTop: "15px",
//                       color: "#6b4a2e",
//                     }}
//                   >
//                     <p style={{ lineHeight: "1.8" }}>
//                       The <strong>Bhaktamar Stotra</strong> is one of Jainism’s
//                       most powerful prayers, composed by Acharya Manatunga. Each verse
//                       holds profound spiritual resonance and is often chanted for
//                       peace, healing, and the removal of obstacles.
//                     </p>
//                     <h4
//                       style={{
//                         color: "#b66b00",
//                         marginTop: "15px",
//                         fontWeight: "600",
//                       }}
//                     >
//                       Key Highlights
//                     </h4>
//                     <ul style={{ lineHeight: "1.8" }}>
//                       <li>📜 Written in Sanskrit by Acharya Manatunga.</li>
//                       <li>🌸 48 verses — each a spiritual vibration.</li>
//                       <li>🧘‍♂️ Daily recitation brings balance & clarity.</li>
//                       <li>🌿 Known for healing and divine protection.</li>
//                     </ul>
//                   </motion.div>
//                 )}
//               </AnimatePresence>

//               <motion.button
//                 onClick={() => setExpandedBhaktamar(!expandedBhaktamar)}
//                 whileHover={{ scale: 1.05 }}
//                 style={{
//                   marginTop: "15px",
//                   background: "linear-gradient(145deg, #c97b2b, #ffb347)",
//                   border: "none",
//                   padding: "10px 25px",
//                   borderRadius: "25px",
//                   color: "#fff",
//                   fontWeight: "600",
//                   cursor: "pointer",
//                   boxShadow: "0 4px 12px rgba(255,150,50,0.4)",
//                 }}
//               >
//                 {expandedBhaktamar ? "Read Less" : "Read More"}
//               </motion.button>
//             </div>
//           </div>
//         </motion.div>

//         {/* 🔶 Dr. Pranamsagar Card */}
//         <motion.div
//           whileHover={{ scale: 1.02 }}
//           transition={{ duration: 0.3 }}
//           className="about-card"
//           style={{
//             borderRadius: "20px",
//             padding: "3px",
//             background:
//               "linear-gradient(135deg, #ffd6b5, #ffe7ba, #f1c27d)", // warm creamy-gold gradient
//             boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
//           }}
//         >
//           <div
//             style={{
//               background: "#fffaf3",
//               borderRadius: "18px",
//               padding: "25px",
//               height: "100%",
//               display: "flex",
//               flexDirection: "column",
//               gap: "20px",
//             }}
//           >
//             <motion.img
//               src="pranamsagarji1.jpg"
//               alt="Dr. Pranamsagar Ji Maharaj"
//               whileHover={{ scale: 1.05 }}
//               transition={{ duration: 0.4 }}
//               style={{
//                 width: "100%",
//                 borderRadius: "15px",
//                 boxShadow: "0 8px 20px rgba(255, 180, 100, 0.4)",
//                 cursor: "pointer",
//                 objectFit: "cover",
//               }}
//             />
//             <div>
//               <h2
//                 style={{
//                   color: "#b66b00",
//                   fontWeight: "700",
//                   marginBottom: "10px",
//                 }}
//               >
//                 Acharya Muni Shri Pranamsagarji Maharaj
//               </h2>
//               <p style={{ fontSize: "1.1rem", color: "#5a3a0e", lineHeight: "1.8" }}>
//                 Revered as “Bhaktamar Wale Baba,” he has inspired millions with his
//                 compassionate teachings, uniting ancient Jain values with modern
//                 thought and social reform.
//               </p>

//               <AnimatePresence>
//                 {expandedDrPranamsagar && (
//                   <motion.div
//                     key="pranamsagar-content"
//                     variants={slideVariant}
//                     initial="hidden"
//                     animate="visible"
//                     exit="exit"
//                     style={{
//                       overflow: "hidden",
//                       marginTop: "15px",
//                       color: "#6b4a2e",
//                     }}
//                   >
//                     <p style={{ lineHeight: "1.8" }}>
//                       <strong>Muni Shri Pranamsagar Ji Maharaj</strong> was born in
//                       1967 and took Diksha in 1988. Through clarity, logic, and
//                       compassion, he bridged spiritual knowledge and practical life.
//                     </p>
//                     <h4
//                       style={{
//                         color: "#b66b00",
//                         marginTop: "15px",
//                         fontWeight: "600",
//                       }}
//                     >
//                       Contributions & Achievements
//                     </h4>
//                     <ul style={{ lineHeight: "1.8" }}>
//                       <li>🎤 Shanka Samadhan: Answers to spiritual queries.</li>
//                       <li>🧘 Bhavna Yoga: A journey to inner calm.</li>
//                       <li>✊ Dharma Bachao Andolan: Protecting Jain principles.</li>
//                       <li>📚 Author of multiple spiritual books.</li>
//                       <li>🏛 Gunayatan Project near Sammed Shikharji.</li>
//                     </ul>
//                   </motion.div>
//                 )}
//               </AnimatePresence>

//               <motion.button
//                 onClick={() => setExpandedDrPranamsagar(!expandedDrPranamsagar)}
//                 whileHover={{ scale: 1.05 }}
//                 style={{
//                   marginTop: "15px",
//                   background: "linear-gradient(145deg, #c97b2b, #ffb347)",
//                   border: "none",
//                   padding: "10px 25px",
//                   borderRadius: "25px",
//                   color: "#fff",
//                   fontWeight: "600",
//                   cursor: "pointer",
//                   boxShadow: "0 4px 12px rgba(255,150,50,0.4)",
//                 }}
//               >
//                 {expandedDrPranamsagar ? "Read Less" : "Read More"}
//               </motion.button>
//             </div>
//           </div>
//         </motion.div>
//       </div>

//       {/* 📱 Responsive Styles */}
//       <style>
//         {`
//           @media (max-width: 992px) {
//             .about-grid {
//               grid-template-columns: 1fr !important;
//               gap: 25px !important;
//               padding: 40px 15px !important;
//             }
//             .about-card {
//               max-width: 600px;
//               margin: 0 auto;
//             }
//             h1 {
//               font-size: 2rem !important;
//             }
//           }

//           @media (max-width: 576px) {
//             h1 {
//               font-size: 1.6rem !important;
//             }
//             p {
//               font-size: 1rem !important;
//             }
//             button {
//               width: 100%;
//             }
//           }
//         `}
//       </style>
//     </div>
//   );
// }

// export default About;


import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

function About() {
  const [expandedBhaktamar, setExpandedBhaktamar] = useState(false);
  const [expandedDrPranamsagar, setExpandedDrPranamsagar] = useState(false);

  const slideVariant = {
    hidden: { opacity: 0, height: 0 },
    visible: { opacity: 1, height: "auto", transition: { duration: 0.7 } },
    exit: { opacity: 0, height: 0, transition: { duration: 0.5 } },
  };

  return (
    <div
      style={{
        fontFamily: "'Poppins', 'Noto Sans Devanagari', sans-serif",
        background: "linear-gradient(to bottom, #fffaf3, #fff4e2)",
        color: "#4b2e05",
      }}
    >
      {/* 🌟 Hero Section */}
      <section
        style={{
          background: "linear-gradient(120deg, #ffd6b5, #ffebb0, #fff4e2)",
          padding: "90px 20px",
          textAlign: "center",
          color: "#4b2e05",
          boxShadow: "inset 0 -5px 15px rgba(255, 200, 100, 0.2)",
        }}
      >
        <motion.h1
          initial={{ opacity: 0, y: -40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          style={{
            fontSize: "2.8rem",
            fontWeight: "800",
            marginBottom: "20px",
            color: "#5a3a0e",
            textShadow: "0 2px 8px rgba(255, 230, 150, 0.5)",
          }}
        >
          About Bhaktamar & Acharya Dr. Pranamsagarji Maharaj
        </motion.h1>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
          style={{
            fontSize: "1.2rem",
            maxWidth: "750px",
            margin: "0 auto",
            lineHeight: "1.8",
            color: "#6b4a2e",
          }}
        >
          Discover the sacred brilliance of <strong>Bhaktamar Stotra</strong> —
          a timeless Sanskrit hymn that connects the soul to divine purity — and
          the profound life of <strong>Acharya Dr. Pranamsagarji Maharaj</strong>,
          whose vision unites devotion, logic, and humanity.
        </motion.p>
      </section>

      {/* 🪶 Cards Grid */}
      <div
        className="about-grid"
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "40px",
          padding: "60px 20px",
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        {/* 🔶 Bhaktamar Card */}
        <motion.div
          whileHover={{ scale: 1.02 }}
          transition={{ duration: 0.3 }}
          className="about-card"
          style={{
            borderRadius: "20px",
            padding: "3px",
            background: "linear-gradient(135deg, #ffe7ba, #ffd6b5, #ffc1a1)",
            boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
          }}
        >
          <div
            style={{
              background: "#fffaf3",
              borderRadius: "18px",
              padding: "25px",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            <motion.img
              src="bhaktamar.jpg"
              alt="Bhaktamar"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.4 }}
              style={{
                width: "100%",
                borderRadius: "15px",
                boxShadow: "0 8px 20px rgba(255, 180, 100, 0.4)",
                cursor: "pointer",
                objectFit: "cover",
              }}
            />
            <div>
              <h2
                style={{
                  color: "#b66b00",
                  fontWeight: "700",
                  marginBottom: "10px",
                }}
              >
                Bhaktamar Stotra
              </h2>
              <p style={{ fontSize: "1.1rem", color: "#5a3a0e", lineHeight: "1.8" }}>
                A revered Sanskrit hymn of 48 verses composed by
                <strong> Acharya Manatunga</strong>, Bhaktamar Stotra is a
                masterpiece of devotion and poetic brilliance. It is known for
                its mystical vibrations that harmonize the mind and soul.
              </p>

              <AnimatePresence>
                {expandedBhaktamar && (
                  <motion.div
                    key="bhaktamar-content"
                    variants={slideVariant}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                    style={{
                      overflow: "hidden",
                      marginTop: "15px",
                      color: "#6b4a2e",
                    }}
                  >
                    <p style={{ lineHeight: "1.8" }}>
                      <strong>Bhaktamar</strong> is derived from two words —
                      “Bhakta” (devotee) and “Amar” (immortal). It expresses the
                      immortal devotion of a soul towards Lord Adinath, the
                      first Tirthankar of Jainism. Each shloka is believed to
                      hold immense spiritual power, capable of healing physical,
                      emotional, and karmic suffering.
                    </p>

                    <h4
                      style={{
                        color: "#b66b00",
                        marginTop: "15px",
                        fontWeight: "600",
                      }}
                    >
                      Key Highlights
                    </h4>
                    <ul style={{ lineHeight: "1.8" }}>
                      <li>📜 Authored in the 7th century by Acharya Manatunga.</li>
                      <li>🌸 48 verses symbolizing 48 divine virtues of enlightenment.</li>
                      <li>🧘‍♀️ Recitation purifies aura and brings spiritual healing.</li>
                      <li>🌿 Each verse is associated with miraculous transformations.</li>
                      <li>🔮 Used for meditation, mental peace, and wish fulfillment.</li>
                    </ul>

                    <h4
                      style={{
                        color: "#b66b00",
                        marginTop: "15px",
                        fontWeight: "600",
                      }}
                    >
                      Miraculous Legacy
                    </h4>
                    <p style={{ lineHeight: "1.8" }}>
                      History mentions that Acharya Manatunga was imprisoned by a
                      king and chained within a dungeon. As he recited each verse,
                      one chain broke miraculously — until he was completely free.
                      This symbolizes how <strong>faith and devotion can free the soul
                      from all karmic bonds.</strong>
                    </p>

                    <h4
                      style={{
                        color: "#b66b00",
                        marginTop: "15px",
                        fontWeight: "600",
                      }}
                    >
                      Philosophical Essence
                    </h4>
                    <p style={{ lineHeight: "1.8" }}>
                      Bhaktamar bridges <strong>poetry, devotion, and spiritual science</strong>.
                      Each shloka resonates with the vibrations of compassion,
                      surrender, and divine intellect. Modern seekers use it for
                      meditation, positivity, and aligning inner consciousness with
                      cosmic harmony.
                    </p>
                  </motion.div>
                )}
              </AnimatePresence>

              <motion.button
                onClick={() => setExpandedBhaktamar(!expandedBhaktamar)}
                whileHover={{ scale: 1.05 }}
                style={{
                  marginTop: "15px",
                  background: "linear-gradient(145deg, #c97b2b, #ffb347)",
                  border: "none",
                  padding: "10px 25px",
                  borderRadius: "25px",
                  color: "#fff",
                  fontWeight: "600",
                  cursor: "pointer",
                  boxShadow: "0 4px 12px rgba(255,150,50,0.4)",
                }}
              >
                {expandedBhaktamar ? "Read Less" : "Read More"}
              </motion.button>
            </div>
          </div>
        </motion.div>

        {/* 🔶 Acharya Dr. Pranamsagar Card */}
        <motion.div
          whileHover={{ scale: 1.02 }}
          transition={{ duration: 0.3 }}
          className="about-card"
          style={{
            borderRadius: "20px",
            padding: "3px",
            background: "linear-gradient(135deg, #ffd6b5, #ffe7ba, #f1c27d)",
            boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
          }}
        >
          <div
            style={{
              background: "#fffaf3",
              borderRadius: "18px",
              padding: "25px",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            <motion.img
              src="pranamsagarji1.jpg"
              alt="Dr. Pranamsagar Ji Maharaj"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.4 }}
              style={{
                width: "100%",
                borderRadius: "15px",
                boxShadow: "0 8px 20px rgba(255, 180, 100, 0.4)",
                cursor: "pointer",
                objectFit: "cover",
              }}
            />
            <div>
              <h2
                style={{
                  color: "#b66b00",
                  fontWeight: "700",
                  marginBottom: "10px",
                }}
              >
                Acharya Muni Shri Pranamsagarji Maharaj
              </h2>
              <p style={{ fontSize: "1.1rem", color: "#5a3a0e", lineHeight: "1.8" }}>
                Revered as <strong>“Bhaktamar Wale Baba”</strong>, Acharya Dr.
                Pranamsagarji Maharaj is a saint-scholar who inspires millions with
                his compassionate teachings, reformative movements, and scientific
                approach to spirituality.
              </p>

              <AnimatePresence>
                {expandedDrPranamsagar && (
                  <motion.div
                    key="pranamsagar-content"
                    variants={slideVariant}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                    style={{
                      overflow: "hidden",
                      marginTop: "15px",
                      color: "#6b4a2e",
                    }}
                  >
                    <p style={{ lineHeight: "1.8" }}>
                      <strong>Born in 1972</strong> in Yavat taluka Daund, District - Pune(Maharashtra), India, Acharya Shri took
                      <strong> Diksha in 2000</strong> under Acharya Shri Pushpadanta Sagar Ji Maharaj.
                      Known for his eloquence and clarity, he has rejuvenated the
                      <strong>Bhaktamar tradition</strong> by linking spirituality with logic,
                      science, and modern-day relevance.
                    </p>

                    <h4
                      style={{
                        color: "#b66b00",
                        marginTop: "15px",
                        fontWeight: "600",
                      }}
                    >
                      Contributions & Achievements
                    </h4>
                    <ul style={{ lineHeight: "1.8" }}>
                      <li>🎤 Founder of <strong>Shanka Samadhan</strong> — an open Q&A platform for spiritual clarity.</li>
                      <li>🧘 Creator of <strong>Bhavna Yoga</strong> for inner calm and focus.</li>
                      <li>✊ Led the <strong>Dharma Bachao Andolan</strong> to protect Jain values and pilgrimage sites.</li>
                      <li>🏛 Visionary behind the <strong>Gunayatan Project</strong> near Sammed Shikharji — a global spiritual hub.</li>
                      <li>📚 Author of several acclaimed spiritual and philosophical texts.</li>
                      <li>🌍 Promotes environment, peace, and youth ethics awareness across India.</li>
                    </ul>

                    <h4
                      style={{
                        color: "#b66b00",
                        marginTop: "15px",
                        fontWeight: "600",
                      }}
                    >
                      Vision & Philosophy
                    </h4>
                    <p style={{ lineHeight: "1.8" }}>
                      Acharya Shri emphasizes <strong>balance between science and faith</strong>,
                      guiding individuals toward rational spirituality. His mission is
                      to restore Jainism’s ancient wisdom in a way that appeals to the
                      youth, fostering compassion, peace, and practical religion.
                    </p>

                    <h4
                      style={{
                        color: "#b66b00",
                        marginTop: "15px",
                        fontWeight: "600",
                      }}
                    >
                      Global Impact
                    </h4>
                    <p style={{ lineHeight: "1.8" }}>
                      Through discourses, digital outreach, and live Bhaktamar
                      sessions, Acharya Shri has inspired seekers worldwide. His
                      philosophy transcends religion — emphasizing harmony,
                      introspection, and the universal oneness of all beings.
                    </p>
                  </motion.div>
                )}
              </AnimatePresence>

              <motion.button
                onClick={() => setExpandedDrPranamsagar(!expandedDrPranamsagar)}
                whileHover={{ scale: 1.05 }}
                style={{
                  marginTop: "15px",
                  background: "linear-gradient(145deg, #c97b2b, #ffb347)",
                  border: "none",
                  padding: "10px 25px",
                  borderRadius: "25px",
                  color: "#fff",
                  fontWeight: "600",
                  cursor: "pointer",
                  boxShadow: "0 4px 12px rgba(255,150,50,0.4)",
                }}
              >
                {expandedDrPranamsagar ? "Read Less" : "Read More"}
              </motion.button>
            </div>
          </div>
        </motion.div>
      </div>

      {/* 📱 Responsive Styles */}
      <style>
        {`
          @media (max-width: 992px) {
            .about-grid {
              grid-template-columns: 1fr !important;
              gap: 25px !important;
              padding: 40px 15px !important;
            }
            .about-card {
              max-width: 600px;
              margin: 0 auto;
            }
            h1 {
              font-size: 2rem !important;
            }
          }

          @media (max-width: 576px) {
            h1 {
              font-size: 1.6rem !important;
            }
            p {
              font-size: 1rem !important;
            }
            button {
              width: 100%;
            }
          }
        `}
      </style>
    </div>
  );
}

export default About;
